/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useState, useEffect, useCallback } from "react";
import { useTheme } from "@material-ui/core/styles";
import { GblContext } from "providers/formatter";
import { useStateWithCallbackLazy } from "use-state-with-callback";
import { useTranslate } from "react-admin";
import { Box, FormControl, Select, InputLabel, MenuItem, Button, Grid } from "@material-ui/core";
import { TableHead, TableRow, TableCell, Tooltip, Icon, IconButton } from "@material-ui/core";
import XLSX from "xlsx-js-style";
import {
  getEditVatReconcileByPrefix,
  exportVatReconcile,
  delEditVatReconcileDetail,
  updateEditVatReconcileDetail,
  createEditVatReconcileDetail,
  getEditVatReconcileList,
} from "services/reconcile";
import { getApVendorList, getTaxProfile } from "services/accountPayable";
import { MTableHeader, MTableToolbar } from "material-table";
import MeterialtableTranslate from "components/MeterialtableTranslate";
import PopupTable from "components/PopupTable";
import { TextFieldInForm, DateInForm, NumberFormatInForm, MuiAutosuggest, DescInForm } from "components/Form";
import { format, addDays, startOfMonth, endOfMonth } from "date-fns";
import Model from "models/editVatReconcile";
import SnackbarUtils from "utils/SnackbarUtils";
import ButtonUpload from "components/ButtonUpload";
import ErrorTableDialog from "components/ErrorTable";
import { callStoreReport } from "services/callStoreProcedure";

const EditVATTab = (props) => {
  const translate = useTranslate();
  const theme = useTheme();
  const {
    settingAll,
    DateToString,
    NumberFormat,
    ToMySqlDate,
    FindTaxAmount,
    ToNumber,
    StringToDate,
    GetSettingCountry,
  } = useContext(GblContext);
  const { SettingClosePeriod, SettingSystem } = settingAll;
  const { ClosePeriodAp } = SettingClosePeriod;
  let newClosePeriodAp = addDays(new Date(ClosePeriodAp), 1);
  const { taxPeriodList } = props;
  // if (GetSettingCountry().countryCode === "JP") {
  //   Model.TaxRate = 8;
  // }
  const [initNewRow] = useStateWithCallbackLazy(Model);
  const [showAdd, setShowAdd] = useState(false);
  const [editIndex, setEditIndex] = useState("");
  const [checkSource, setCheckSource] = useState(false);
  const [defaultTaxPeriod, setDefaultTaxPeriod] = useState(format(new Date(), "MM/yyyy"));
  const [filterDate, setFilterDate] = useState({
    from: "",
    to: "",
  });
  const [fileImportInputTax, setFileImportInputTax] = useState();
  const [filterTaxProfile, setFilterTaxProfile] = useState("All");
  const [Data, setData] = useState();
  const [Prefix, setPrefix] = useState();
  const [isLoading, setLoading] = useState(true);
  const [lookupList, setLookupList] = useState({
    vendorList: [],
    taxProfileList: [],
  });
  const [errorTable, setErrorTable] = useState(false);
  const [showErrorTable, setShowErrorTable] = useState(false);
  const handleFilterList = async (period = defaultTaxPeriod) => {
    var year = period.substring(3, 8);
    var month = period.substring(0, 2);
    var monthInt = parseInt(month) - 1;
    let filterDate = new Date(year, monthInt);
    let startDayOfMonth = ToMySqlDate(startOfMonth(filterDate));
    let endDayOfMonth = ToMySqlDate(endOfMonth(filterDate));
    setFilterDate((state) => ({
      ...state,
      from: startDayOfMonth,
      to: endDayOfMonth,
    }));

    const { Code } = await exportVatReconcile(startDayOfMonth, endDayOfMonth);
    if (Code === 0) {
      setPrefix(`vat${year}${month}`);
    }
  };

  const fetchVendorLookup = useCallback(async () => {
    const { Data } = await getApVendorList();
    setLookupList((state) => ({
      ...state,
      vendorList: Data,
    }));
  }, []);

  const fetchTaxProfile = async () => {
    const { Data } = await getTaxProfile();
    setLookupList((state) => ({
      ...state,
      taxProfileList: Data,
    }));
  };

  const fetchSearchList = async (prefix = Prefix, filterTaxRate = "All", mounted) => {
    const { Data } = await getEditVatReconcileByPrefix(prefix, filterTaxRate);
    if (Data) {
      setData(Data);
    } else {
      setData([]);
    }
    if (mounted) {
      setLoading(false);
    }
  };

  useEffect(() => {
    let mounted = true;
    fetchVendorLookup();
    fetchTaxProfile();
    if (Prefix) {
      fetchSearchList(Prefix, filterTaxProfile, mounted);
    } else {
      handleFilterList();
    }
    return function cleanup() {
      mounted = false;
    };
  }, [Prefix, filterTaxProfile]);

  const columns = [
    {
      title: " ",
      field: "Id",
      sorting: true,
      render: (rowData) => {
        return (
          <div style={{ display: "flex" }}>
            <Tooltip title={`Edit ${rowData.Id}`}>
              <IconButton
                size="small"
                color="primary"
                style={{ cursor: "pointer" }}
                onClick={() => UpdateRow(rowData.Id)}
              >
                <Icon>edit</Icon>
              </IconButton>
            </Tooltip>
            {rowData.Source !== "Exported" && (
              <Tooltip title={`Delete ${rowData.Id}`}>
                <IconButton
                  size="small"
                  color="primary"
                  style={{ cursor: "pointer" }}
                  onClick={async () => {
                    let msg = translate("ra.question.confirmDel");
                    SnackbarUtils.delConfirm(msg, async function () {
                      const { Code, UserMessage, InternalMessage } = await delEditVatReconcileDetail(rowData.Id);
                      if (Code === 0) {
                        SnackbarUtils.success(UserMessage, function () {
                          fetchSearchList();
                        });
                      } else {
                        SnackbarUtils.warning(InternalMessage, function () {
                          fetchSearchList();
                        });
                      }
                    });
                  }}
                >
                  <Icon>delete</Icon>
                </IconButton>
              </Tooltip>
            )}
          </div>
        );
      },
    },
    { title: "Source", field: "Source", sorting: true },
    { title: "Tax Inv No.", field: "InvhTInvNo", sorting: true, width: 400 },
    {
      title: "Tax Inv Date",
      field: "InvhTInvDt",
      sorting: true,
      render: (rowData) => {
        let value = rowData.InvhTInvDt;
        if (!rowData.InvhTInvDt) {
          return null;
        }
        return DateToString(value ?? new Date());
      },
    },
    {
      title: "Vendor Name",
      field: "VnName",
      sorting: true,
      cellStyle: {
        width: 200,
      },
    },
    { title: "TAX ID.", field: "TaxId", sorting: true },
    {
      title: "Branch No.",
      field: "BranchNo",
      sorting: true,
      render: (rowData) => rowData.BranchNo ?? "",
    },
    {
      title: "Description",
      field: "InvhDesc",
      sorting: true,
      cellStyle: {
        width: 200,
      },
    },
    {
      title: "Tax Profile",
      field: "TaxProfileCode",
      sorting: true,
      render: (rowData) =>
        rowData.TaxProfileDesc ? `${rowData.TaxProfileCode} : ${rowData.TaxProfileDesc}` : rowData.TaxProfileCode,
    },
    {
      title: "Tax Rate %",
      field: "TaxRate",
      sorting: true,
      type: "numeric",
      render: (rowData) => NumberFormat(rowData.TaxRate),
    },
    {
      title: "Net Amount",
      field: "BfTaxAmt",
      sorting: true,
      type: "numeric",
      render: (rowData) => NumberFormat(rowData.BfTaxAmt),
    },
    {
      title: "Tax",
      field: "TaxAmt",
      sorting: true,
      type: "numeric",
      render: (rowData) => NumberFormat(rowData.TaxAmt),
    },
    {
      title: "Total",
      field: "TotalAmt",
      sorting: true,
      type: "numeric",
      render: (rowData) => NumberFormat(rowData.TotalAmt),
    },
  ];

  const options = {
    draggable: false,
    headerStyle: {
      backgroundColor: theme.palette.primary.main,
      color: "#FFF",
    },
    rowStyle: (item) => {
      if (item.tableData.id % 2) {
        return { backgroundColor: "#f2f2f2" };
      }
    },
    padding: "dense",
    paging: true,
    pageSize: 15,
    pageSizeOptions: [15, 50, 100],
    selection: false,
    selectionProps: () => ({
      color: "primary",
    }),
  };

  const CustomFilterList = (props) => {
    return (
      <>
        <MTableToolbar {...props} />
        <Box display="flex" style={{ marginTop: -50 }}>
          <Box p={1}>
            {taxPeriodList ? (
              <FormControl variant="outlined" fullWidth>
                <InputLabel id="label">filter data by tax period</InputLabel>
                <Select
                  labelId="label"
                  variant="outlined"
                  margin="dense"
                  label={"filter data by tax period"}
                  style={{ width: 160 }}
                  value={defaultTaxPeriod}
                  onChange={(e) => {
                    setDefaultTaxPeriod(e.target.value);
                    handleFilterList(e.target.value);
                  }}
                >
                  {taxPeriodList
                    ? taxPeriodList.map((item) => (
                        <MenuItem key={item?.toString()} value={item}>
                          {item}
                        </MenuItem>
                      ))
                    : ""}
                </Select>
              </FormControl>
            ) : (
              ""
            )}
          </Box>
          <Box p={1}>
            <FormControl variant="outlined" fullWidth>
              <InputLabel id="labelwht">filter data by tax profile</InputLabel>
              <Select
                labelId="labelwht"
                variant="outlined"
                margin="dense"
                label={"filter data by tax profile"}
                style={{ width: 160 }}
                value={filterTaxProfile}
                onChange={(e) => {
                  setFilterTaxProfile(e.target.value);
                }}
              >
                <MenuItem value={"All"}>{translate("ra.field.All")}</MenuItem>
                {lookupList["taxProfileList"] !== undefined &&
                  lookupList["taxProfileList"].map((i, index) => (
                    <MenuItem value={i.Code} key={index}>
                      {i.Code} {i.Description ? `: ${i.Description}` : ""}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Box>
        </Box>
      </>
    );
  };

  const CustomHeader = (props) => {
    return (
      <>
        <TableHead>
          <TableRow>
            <TableCell align="left" colSpan={12} style={{ padding: "4px 16px" }}>
              <Grid container alignItems="center" spacing={1}>
                <Grid item>
                  <IconButton size="small" onClick={AddNewRow}>
                    <Icon>add</Icon>
                  </IconButton>
                </Grid>
                <Grid item>
                  <ButtonUpload
                    id="fileImportInputTax"
                    name="fileImportInputTax"
                    style={{ display: "none" }}
                    type="file"
                    onChange={uploadFile}
                    accept=".xlsx,.xls"
                    fileUpload={fileImportInputTax?.name}
                    btntext={"import from file"}
                    noCaption
                    cancelUpload={() => {
                      setFileImportInputTax();
                      document.getElementById("fileImportInputTax").value = "";
                    }}
                  />
                </Grid>
                <Grid item>
                  <Button variant="outlined" onClick={exportTemplateFile}>
                    <Icon fontSize="small" style={{ marginRight: 5 }}>
                      cloud_download
                    </Icon>{" "}
                    export template
                  </Button>
                </Grid>
              </Grid>
            </TableCell>
            <TableCell align="right" colSpan={6} />
          </TableRow>
        </TableHead>
        <MTableHeader {...props} />
      </>
    );
  };

  const AddNewRow = () => {
    setEditIndex("");
    setShowAdd(true);
    setCheckSource(false);
  };

  const uploadFile = async (e) => {
    setLoading(true);
    if (e.target.files.length >= 1) {
      let file = e.target.files[0];
      setFileImportInputTax(file);
      const buf = await file.arrayBuffer();
      const wb = XLSX.read(buf, { type: "array", cellDates: true });
      const ws = wb.Sheets[wb.SheetNames[0]];
      const opts = { raw: false, dateNF: settingAll.SettingSystem.DateFormat, strip: true, skipHidden: true };
      const json = XLSX.utils.sheet_to_json(ws, opts);

      //validate json
      if (json.length === 0) {
        SnackbarUtils.error("No data in file");
        setLoading(false);
        return;
      }

      //loop push json with rowindex if Tax Inv No.is undefined
      const rowsError = [];
      for (const [i] of json.entries()) {
        if (json[i]["Tax Inv No."] === undefined) {
          rowsError.push({
            row: i + 2,
            message: "Tax Inv No. on Row " + (i + 2) + " is empty",
          });
        }
        if (json[i]["Tax Inv Date (DD/MM/YY)"] === undefined) {
          rowsError.push({
            row: i + 2,
            message: "Tax Inv Date on Row " + (i + 2) + " is empty",
          });
        }
        if (json[i]["Tax Inv Date (DD/MM/YY)"] !== undefined) {
          let sDate = json[i]["Tax Inv Date (DD/MM/YY)"];
          let date = StringToDate(sDate);
          if (isNaN(date)) {
            rowsError.push({
              row: i + 2,
              message: "Tax Inv Date on Row " + (i + 2) + " is invalid",
            });
          }
        }
        if (json[i]["Tax ID (13 Digits)"] === undefined) {
          rowsError.push({
            row: i + 2,
            message: "Tax ID on Row " + (i + 2) + " is empty",
          });
        }
        if (json[i]["Tax ID (13 Digits)"] !== undefined && json[i]["Tax ID (13 Digits)"].length < 13) {
          rowsError.push({
            row: i + 2,
            message: "Tax ID on Row " + (i + 2) + " is invalid",
          });
        }
        if (json[i]["Branch No."] === undefined) {
          rowsError.push({
            row: i + 2,
            message: "Branch No. on Row " + (i + 2) + " is empty",
          });
        }
        if (json[i]["Vendor Name"] === undefined) {
          rowsError.push({
            row: i + 2,
            message: "Vendor Name on Row " + (i + 2) + " is empty",
          });
        }
        if (json[i]["Address"] === undefined) {
          rowsError.push({
            row: i + 2,
            message: "Address on Row " + (i + 2) + " is empty",
          });
        }
        if (json[i]["Tax Profile (VAT07, NONE)"] === undefined) {
          rowsError.push({
            row: i + 2,
            message: "Tax Profile (VAT07, NONE) on Row " + (i + 2) + " is empty",
          });
        }
        if (json[i]["Tax Profile (VAT07, NONE)"] !== undefined) {
          let arroftax = ["VAT07", "NONE"];
          if (!arroftax.includes(json[i]["Tax Profile (VAT07, NONE)"])) {
            rowsError.push({
              row: i + 2,
              message: "Tax Profile on Row " + (i + 2) + " is invalid",
            });
          }
        }
        if (json[i]["Net Amount"] === undefined) {
          rowsError.push({
            row: i + 2,
            message: "Net Amount on Row " + (i + 2) + " is empty",
          });
        }
        if (json[i]["Tax Rate %"] === undefined) {
          rowsError.push({
            row: i + 2,
            message: "Tax Rate % on Row " + (i + 2) + " is empty",
          });
        }
        if (json[i]["Tax Amount"] === undefined) {
          rowsError.push({
            row: i + 2,
            message: "Tax Amount on Row " + (i + 2) + " is empty",
          });
        }
      }

      if (rowsError.length > 0) {
        setLoading(false);
        setErrorTable(rowsError);
        setShowErrorTable(true);
        return;
      }

      let q = {
        limit: 0,
        whereRaw: `Source = 'i' AND FrDate = '${filterDate.from}' AND ToDate = '${filterDate.to}'`,
      };
      const vrList = await getEditVatReconcileList(q);
      if (vrList.Data.length > 0) {
        SnackbarUtils.delConfirmWithTitle(
          "Warning: Data Will Be Overwritten",
          "Data from a previous import already exists. Continuing will first delete all existing data and then import the new file.",
          async function () {
            let p = {
              fromPeriod: filterDate.from,
              toPeriod: filterDate.to,
            };
            await callStoreReport("spRemoveVatReconStatusImport", p);
            //add index
            for (const [i] of json.entries()) {
              json[i].FrDate = filterDate.from;
              json[i].ToDate = filterDate.to;
              //create
              let newParam = {
                ...initNewRow,
                Prefix: Prefix,
                Source: "Import",
                FrDate: json[i].FrDate,
                ToDate: json[i].ToDate,
                InvhTInvNo: json[i]["Tax Inv No."],
                InvhTInvDt: StringToDate(json[i]["Tax Inv Date (DD/MM/YY)"]),
                TaxId: json[i]["Tax ID (13 Digits)"],
                BranchNo: json[i]["Branch No."],
                InvhDesc: json[i]["Description"],
                Address: json[i]["Address"],
                VnName: json[i]["Vendor Name"],
                TaxProfileCode: json[i]["Tax Profile (VAT07, NONE)"],
                TaxProfileDesc: lookupList["taxProfileList"].find(
                  (item) => item.Code === json[i]["Tax Profile (VAT07, NONE)"]
                )?.Description,
                BfTaxAmt: ToNumber(json[i]["Net Amount"]),
                TaxRate: ToNumber(json[i]["Tax Rate %"]),
                TaxAmt: ToNumber(json[i]["Tax Amount"]),
                TotalAmt: ToNumber(json[i]["Net Amount"]) + ToNumber(json[i]["Tax Amount"]),
                UserModified: localStorage.getItem("UserName"),
              };
              const { Code, InternalMessage, UserMessage } = await createEditVatReconcileDetail(newParam);
              if (Code === 0 && i === json.length - 1) {
                SnackbarUtils.success(UserMessage, function () {
                  setLoading(false);
                  setShowAdd(false);
                  //clear file after import
                  setFileImportInputTax();
                  document.getElementById("fileImportInputTax").value = "";
                  fetchSearchList();
                });
              } else if (Code !== 0 && i === json.length - 1) {
                setLoading(false);
                SnackbarUtils.warning(InternalMessage, function () {
                  fetchSearchList();
                });
              } else {
                continue;
              }
            }
          },
          () => {
            setLoading(false);
            return;
          }
        );
      } else {
        //add index
        for (const [i] of json.entries()) {
          json[i].FrDate = filterDate.from;
          json[i].ToDate = filterDate.to;
          //create
          let newParam = {
            ...initNewRow,
            Prefix: Prefix,
            Source: "Import",
            FrDate: json[i].FrDate,
            ToDate: json[i].ToDate,
            InvhTInvNo: json[i]["Tax Inv No."],
            InvhTInvDt: StringToDate(json[i]["Tax Inv Date (DD/MM/YY)"]),
            TaxId: json[i]["Tax ID (13 Digits)"],
            BranchNo: json[i]["Branch No."],
            InvhDesc: json[i]["Description"],
            Address: json[i]["Address"],
            VnName: json[i]["Vendor Name"],
            TaxProfileCode: json[i]["Tax Profile (VAT07, NONE)"],
            TaxProfileDesc: lookupList["taxProfileList"].find(
              (item) => item.Code === json[i]["Tax Profile (VAT07, NONE)"]
            )?.Description,
            BfTaxAmt: ToNumber(json[i]["Net Amount"]),
            TaxRate: ToNumber(json[i]["Tax Rate %"]),
            TaxAmt: ToNumber(json[i]["Tax Amount"]),
            TotalAmt: ToNumber(json[i]["Net Amount"]) + ToNumber(json[i]["Tax Amount"]),
            UserModified: localStorage.getItem("UserName"),
          };
          const { Code, InternalMessage, UserMessage } = await createEditVatReconcileDetail(newParam);
          if (Code === 0 && i === json.length - 1) {
            SnackbarUtils.success(UserMessage, function () {
              setLoading(false);
              setShowAdd(false);
              //clear file after import
              setFileImportInputTax();
              document.getElementById("fileImportInputTax").value = "";
              fetchSearchList();
            });
          } else if (Code !== 0 && i === json.length - 1) {
            setLoading(false);
            SnackbarUtils.warning(InternalMessage, function () {
              fetchSearchList();
            });
          } else {
            continue;
          }
        }
      }
    } else {
      if (e.target.id === "fileImportInputTax") {
        document.getElementById("fileImportInputTax").value = "";
        setLoading(false);
      }
    }
  };

  const exportTemplateFile = async () => {
    const a = document.createElement("a");
    a.href = process.env.PUBLIC_URL + "/Input_Tax_Template.xlsx";
    a.download = "Input_Tax_Template.xlsx";
    a.click();
    window.URL.revokeObjectURL(process.env.PUBLIC_URL + "/Input_Tax_Template.xlsx");
  };

  const UpdateRow = (index) => {
    setEditIndex(index);
    setShowAdd(true);
    let selectedItem = Data.find((item) => item.Id === index);
    setCheckSource(selectedItem.Source === "Exported");
  };

  const UpdateFromPopup = (currentField, m, data) => {
    if (currentField === "TaxRate") {
      let TaxAmt = FindTaxAmount("Add", data["TaxRate"], data["BfTaxAmt"]);
      m.setValue("TaxRate", ToNumber(data["TaxRate"]));
      m.setValue("TaxAmt", ToNumber(TaxAmt));
      m.setValue("TotalAmt", ToNumber(data["BfTaxAmt"]) + ToNumber(TaxAmt));
    }
    if (currentField === "BfTaxAmt") {
      let TaxAmt = FindTaxAmount("Add", data["TaxRate"], data["BfTaxAmt"]);
      m.setValue("TaxAmt", TaxAmt);
      m.setValue("TotalAmt", ToNumber(data["BfTaxAmt"]) + ToNumber(TaxAmt));
    }
    if (currentField === "TaxAmt") {
      //let TaxAmt = FindTaxAmount("Add", data["TaxAmt"], data["BfTaxAmt"]);
      m.setValue("TotalAmt", ToNumber(data["BfTaxAmt"]) + ToNumber(data["TaxAmt"]));
    }
  };

  const SaveFromPopup = async (arr, row) => {
    row.FrDate = filterDate.from;
    row.ToDate = filterDate.to;
    if (editIndex !== "") {
      //update
      const { Code, InternalMessage, UserMessage } = await updateEditVatReconcileDetail(row);
      if (Code === 0) {
        SnackbarUtils.success(UserMessage, function () {
          setShowAdd(false);
          fetchSearchList();
        });
      } else {
        SnackbarUtils.warning(InternalMessage, function () {
          fetchSearchList();
        });
      }
    } else {
      //create
      let newParam = {
        ...initNewRow,
        ...row,
        Prefix: Prefix,
      };
      const { Code, InternalMessage, UserMessage } = await createEditVatReconcileDetail(newParam);
      if (Code === 0) {
        SnackbarUtils.success(UserMessage, function () {
          setShowAdd(false);
          fetchSearchList();
        });
      } else {
        SnackbarUtils.warning(InternalMessage, function () {
          fetchSearchList();
        });
      }
    }
  };
  const CancelFromPopup = () => {
    setShowAdd(false);
  };

  const formFieldsDetail = [
    {
      size: 3,
      field: (
        <TextFieldInForm
          label={`*${translate("ra.field.Tax Inv No.")}`}
          name="InvhTInvNo"
          variant="outlined"
          margin="dense"
          rule={{
            required: {
              value: true,
              message: "* Required",
            },
            maxLength: {
              value: 30,
              message: "maximum length is 30",
            },
          }}
          disabled={checkSource}
        />
      ),
    },
    {
      size: 3,
      field: (
        <DateInForm
          label={`${translate("ra.field.Tax Inv Date")}`}
          name="InvhTInvDt"
          style={{ marginTop: -18 }}
          minDate={!checkSource ? new Date(newClosePeriodAp) : undefined}
          minDateMessage={"Date must be more than close period"}
          // rule={
          //   checkSource
          //     ? {
          //         required: {
          //           value: true,
          //           message: "* Required",
          //         },
          //       }
          //     : undefined
          // }
          disabled={checkSource}
        />
      ),
    },
    {
      size: 3,
      field: (
        <TextFieldInForm
          label={`${GetSettingCountry().countryCode !== "PH" ? "*" : ""} ${translate("ra.field.TAX ID.")}`}
          name="TaxId"
          variant="outlined"
          margin="dense"
          rule={{
            required: {
              value: GetSettingCountry().countryCode !== "PH",
              message: "* Required",
            },
            maxLength: {
              value: 30,
              message: "maximum length is 30",
            },
          }}
          disabled={GetSettingCountry().countryCode === "PH"}
        />
      ),
    },
    {
      size: 3,
      field: (
        <TextFieldInForm
          label={`${GetSettingCountry().countryCode !== "PH" ? "*" : ""} ${translate("ra.field.Branch No.")}`}
          name="BranchNo"
          variant="outlined"
          margin="dense"
          rule={{
            required: {
              value: GetSettingCountry().countryCode !== "PH",
              message: "* Required",
            },
            maxLength: {
              value: 20,
              message: "maximum length is 20",
            },
          }}
          disabled={GetSettingCountry().countryCode === "PH"}
        />
      ),
    },
    {
      size: 3,
      field: (
        <MuiAutosuggest
          label={`${GetSettingCountry().countryCode === "PH" ? "*" : ""} ${translate("ra.field.Vendor")}`}
          name="VnCode"
          optKey="VnCode"
          optDesc="VnName"
          options={lookupList["vendorList"]}
          useFncUpdate={true}
          fncUpdate={(value, methods) => {
            methods.setValue("VnName", value.VnName);
            methods.setValue("TaxId", value.VnTaxNo);
            methods.setValue("BranchNo", value.BranchNo);
            methods.setValue("TaxProfileCode", value.TaxProfileCode1);
            methods.setValue("TaxRate", value.VnTaxR1);
            const mergeVnAdd = `${value["VnAdd1"]} ${value["VnAdd2"]} ${value["VnAdd3"]}`;
            methods.setValue("Address", mergeVnAdd);
          }}
          style={{ marginBottom: 18 }}
          rule={{
            required: {
              value: GetSettingCountry().countryCode === "PH",
              message: "* Required",
            },
          }}
        />
      ),
    },
    {
      size: 9,
      field: (
        <TextFieldInForm
          label={`${GetSettingCountry().countryCode !== "PH" ? "*" : ""} ${translate("ra.field.Vendor Name")}`}
          name="VnName"
          variant="outlined"
          margin="dense"
          rule={{
            required: {
              value: GetSettingCountry().countryCode !== "PH",
              message: "* Required",
            },
            maxLength: {
              value: 255,
              message: "maximum length is 255",
            },
          }}
          disabled={GetSettingCountry().countryCode === "PH"}
        />
      ),
    },
    {
      size: 12,
      field: (
        <TextFieldInForm
          label={`${GetSettingCountry().countryCode !== "PH" ? "*" : ""} ${translate("ra.field.Address")}`}
          name="Address"
          variant="outlined"
          margin="dense"
          rule={{
            required: {
              value: GetSettingCountry().countryCode !== "PH",
              message: "* Required",
            },
            maxLength: {
              value: 255,
              message: "maximum length is 255",
            },
          }}
          disabled={GetSettingCountry().countryCode === "PH"}
        />
      ),
    },
    {
      size: 12,
      field: (
        <TextFieldInForm
          label={translate("ra.field.Description")}
          name="InvhDesc"
          variant="outlined"
          margin="dense"
          rule={{
            maxLength: {
              value: 255,
              message: "maximum length is 255",
            },
          }}
          disabled={checkSource}
        />
      ),
    },
    {
      size: 2,
      field: (
        <MuiAutosuggest
          label={`* Tax Profile`}
          name="TaxProfileCode"
          optKey="Code"
          optDesc={"Description"}
          options={lookupList["taxProfileList"]}
          //updateOtherField={[{ key: "InvdTaxR1", optKey: "TaxRate" }]}
          useFncUpdate={true}
          fncUpdate={(value, methods) => {
            if (!value) {
              methods.setValue("TaxRate", 0);
              methods.setValue("TaxProfileDesc", value.Description);
            } else {
              if (value.TaxRate === 0) {
                methods.setValue("TaxRate", 0);
                methods.setValue("TaxProfileDesc", value.Description);
              } else {
                methods.setValue("TaxRate", value.TaxRate);
                methods.setValue("TaxProfileDesc", value.Description);
              }
            }
          }}
          rule={{
            required: {
              value: true,
              message: "* Required",
            },
          }}
        />
      ),
    },
    {
      size: 1,
      name: "TaxProfileDesc",
      field: (
        <DescInForm
          name="TaxProfileDesc"
          InputProps={{
            readOnly: true,
          }}
        />
      ),
    },
    {
      size: 2,
      field: (
        <NumberFormatInForm
          label={`*${translate("ra.field.Net Amount")}`}
          name="BfTaxAmt"
          decimal={SettingSystem.CurrencyBaseDecimal}
          decimalSep={SettingSystem.DecimalSeparator}
          thousandSep={SettingSystem.ThousandSeparator}
          rule={{
            required: {
              value: true,
              message: "* Required",
            },
          }}
          disabled={checkSource}
        />
      ),
    },
    {
      size: 2,
      field: (
        <NumberFormatInForm
          label={`*${translate("ra.field.Tax Rate %")}`}
          name="TaxRate"
          decimal={SettingSystem.CurrencyBaseDecimal}
          decimalSep={SettingSystem.DecimalSeparator}
          thousandSep={SettingSystem.ThousandSeparator}
          rule={{
            required: {
              value: true,
              message: "* Required",
            },
          }}
          disabled={!GetSettingCountry().countryCode !== "JP" ? true : checkSource}
        />
      ),
    },
    {
      size: 2,
      field: (
        <NumberFormatInForm
          label={`*${translate("ra.field.Tax")}`}
          name="TaxAmt"
          decimal={SettingSystem.CurrencyBaseDecimal}
          decimalSep={SettingSystem.DecimalSeparator}
          thousandSep={SettingSystem.ThousandSeparator}
          rule={{
            required: {
              value: true,
              message: "* Required",
            },
          }}
          disabled={checkSource}
        />
      ),
    },
    {
      size: 3,
      field: (
        <NumberFormatInForm
          label={translate("ra.field.Total")}
          name="TotalAmt"
          decimal={SettingSystem.CurrencyBaseDecimal}
          decimalSep={SettingSystem.DecimalSeparator}
          thousandSep={SettingSystem.ThousandSeparator}
          disabled={true}
        />
      ),
    },
  ];

  return (
    <>
      {/* <ActionMenu justifyContent="flex-start" menuControl={menuControlProp} /> */}
      <MeterialtableTranslate
        title=""
        data={Data}
        columns={columns}
        options={options}
        isLoading={isLoading}
        components={{
          Header: CustomHeader,
          Toolbar: CustomFilterList,
        }}
      />
      {showAdd && (
        <PopupTable
          initialValues={editIndex !== "" ? Data.find((i) => i.Id === editIndex) : initNewRow}
          formFields={formFieldsDetail}
          update={UpdateFromPopup}
          open={showAdd}
          save={(row) => SaveFromPopup(Data, row)}
          cancel={CancelFromPopup}
          maxWidth={"md"}
        />
      )}

      {showErrorTable && (
        <ErrorTableDialog
          open={showErrorTable}
          onClose={() => setShowErrorTable(false)}
          errorTable={errorTable}
          keyTable={Object.keys(errorTable[0])}
        />
      )}
    </>
  );
};

export default EditVATTab;
